export function filterByObject(obj1: {[key: string]: any}, obj2: any) {
    return Object.keys(obj2).reduce<typeof obj2>((acc, key) => {
        acc[key] = obj1[key]
        return acc
    }, {})
}
